export const MAX_QUERY_TIME = 5000;
export const MAX_INT_32 = 9999999999;

export const REGISTER_CLICK_EVENT_NAME = 'register-click';
export const TRIGGER_SEARCH_EVENT_NAME = 'trigger-search';
export const UPDATE_SEARCH_EVENT_NAME = 'update-search';
